/** @jsx h */
import { h } from 'preact'
import { useEffect, useRef } from 'preact/hooks'
import Icon from './icons/icons'

export const Dialog = ({ isOpen, onClose, children, className }) => {
  const ref = useRef(null)

  const handleCloseClick = () => ref.current?.close()

  const handleBackdropClick = e => {
    const dialogDimensions = ref.current?.getBoundingClientRect()
    if (
      dialogDimensions &&
      (e.clientX < dialogDimensions.left ||
        e.clientX > dialogDimensions.right ||
        e.clientY < dialogDimensions.top ||
        e.clientY > dialogDimensions.bottom)
    ) {
      handleCloseClick()
    }
  }

  useEffect(() => {
    if (isOpen) {
      ref.current?.showModal()
      document.body.classList.add('modal-open') // prevent bg scroll
    } else {
      handleCloseClick()
      document.body.classList.remove('modal-open')
    }
  }, [isOpen])

  return (
    <dialog
      className={`${className} rcc-max-w-4xl mobile:rcc-h-screen mobile:rcc-max-h-screen`}
      ref={ref}
      onClick={handleBackdropClick}
      onClose={onClose}
    >
      <button
        type='button'
        onClick={handleCloseClick}
        aria-label='Close modal'
        className={`rcc-h-[28px] rcc-bg-transparent rcc-sticky rcc-top-0 rcc-float-right rcc-cursor-pointer`}
      >
        <Icon name='close' height={18} width={18} />
      </button>
      {children}
    </dialog>
  )
}
